import { register } from 'tmr/tmr/ngModuleRegistry'

import './validators'

import * as contentClass from './contentClass/contentClass'
import * as ifAccess from './ifAccess/ifAccess'
import * as ifCapability from './ifCapability/ifCapability'
import * as isolateForm from './isolateForm/isolateForm'
import * as onError from './onError/onError'
import * as resourceActions from './resourceActions/resourceActions'
import * as resourcePolling from './resourcePolling/resourcePolling'

export default register(
  'tmr.core.directives',
  contentClass,
  ifAccess,
  ifCapability,
  isolateForm,
  onError,
  resourceActions,
  resourcePolling
)
